import module from 'kendu/legacy/module'
import './style.scss'

export class ComboboxMenuOptionsComponent {
}

module.component('comboboxMenuOptions', {
  controller: ComboboxMenuOptionsComponent,
})



// WEBPACK FOOTER //
// ./src/deprecated/directive/combobox/menu-options/component.js